import {createContext,useContext,useMemo} from 'react';
import {api} from '@/lib/api';
import {useAuth} from '@/context/AuthContext';
const Context=createContext(null);
export function CommerceScopeProvider({brand,context,channel,children}){
 const value=useMemo(()=>{
  const config={headers:{'X-TPS-Brand':brand.id}};
  const scoped={client:{get:(url,cfg)=>api.client.get(url,{...cfg,headers:{...cfg?.headers,...config.headers}})},get:(url,cfg)=>api.get(url,{...cfg,headers:{...cfg?.headers,...config.headers}}),post:(url,data)=>api.post(url,data,config),put:(url,data)=>api.put(url,data,config),patch:(url,data)=>api.patch(url,data,config),del:url=>api.del(url,config)};
  return {brand,context,channel,api:scoped};
 },[brand,context,channel]);
 return <Context.Provider value={value}>{children}</Context.Provider>;
}
export const useCommerceScope=()=>useContext(Context);
export const useCommerceApi=()=>useContext(Context)?.api||api;
export function useCommerceAuth(){
 const auth=useAuth(),scope=useContext(Context);
 if(!scope)return auth;
 const writable=scope.context.permissions.includes((scope.channel||'shop')+'.manage');
 return {...auth,studio:scope.brand,entitlements:{...scope.context.entitlements,read_only:scope.context.entitlements.read_only||!writable},
  workspace:{role:writable?'studio_owner':'manager',scope:{studio_id:scope.brand.id},capabilities:{inventory:['read']}},hasModule:key=>key==='inventory'};
}
export function useCommercePath(){const scope=useContext(Context);return channel=>scope?'/brand-console/'+scope.brand.id+'/'+channel:(channel==='shop'?'/shop-management':'/supply');}
